module.exports = "/_next/static/images/Inc500-2f1f3201ca966fa7cb42fbee2f924c6d.png";